import { Component, OnInit } from '@angular/core';

declare function initPage(): any;

@Component({
    selector: 'drme-toolbar',
    templateUrl: './toolbar.component.html',
    styleUrls: ['./toolbar.component.css'],
})
export class ToolbarComponent implements OnInit {

    constructor() { }

    ngOnInit(): void {
        initPage();
    }

    public onMobileNavToggle() {
        // document.getElementById('navbar').classList.toggle('navbar-mobile');
        // document.getElementById('mobileNav').classList.toggle('bi-list');
        // document.getElementById('mobileNav').classList.toggle('bi-x');
    }
}

